import { createAction, props } from '@ngrx/store';
import { CentralEmailResponse, NotificationRecipient } from '../../../../projects/client';

export namespace NotificationsActions {
  export enum Type {
    GET_MAIL_SUBSCRIPTION = '[SETTINGS] Get mail subscription',
    GET_MAIL_SUBSCRIPTION_SUCCESS = '[SETTINGS] Get mail subscription success',
    GET_MAIL_SUBSCRIPTION_ERROR = '[SETTINGS] Get mail subscription error',
    SET_MAIL_SUBSCRIPTION = '[SETTINGS] Set mail subscription',
    SET_MAIL_SUBSCRIPTION_SUCCESS = '[SETTINGS] Set mail subscription success',
    SET_MAIL_SUBSCRIPTION_ERROR = '[SETTINGS] Set mail subscription error',

    GET_CENTRAL_EMAIL = '[SETTINGS] Get Central Email',
    GET_CENTRAL_EMAIL_SUCCESS = '[SETTINGS] Get Central Email Success',
    GET_CENTRAL_EMAIL_ERROR = '[SETTINGS] Get Central Email Error',
    GET_CENTRAL_EMAIL_NO_EMAIL_FOUND = '[SETTINGS] Get Central Email No Email Found',
    SET_CENTRAL_EMAIL = '[SETTINGS] Set Central Email',
    SET_CENTRAL_EMAIL_SUCCESS = '[SETTINGS] Set Central Email Success',
    SET_CENTRAL_EMAIL_ERROR = '[SETTINGS] Set Central Email Error',
    UPDATE_CENTRAL_EMAIL = '[SETTINGS] Update Central Email',
    UPDATE_CENTRAL_EMAIL_SUCCESS = '[SETTINGS] Update Central Email Success',
    UPDATE_CENTRAL_EMAIL_ERROR = '[SETTINGS] Update Central Email Error',
    DELETE_CENTRAL_EMAIL = '[SETTINGS] Delete Central Email',
    DELETE_CENTRAL_EMAIL_SUCCESS = '[SETTINGS] Delete Central Email Success',
    DELETE_CENTRAL_EMAIL_ERROR = '[SETTINGS] Delete Central Email Error',

    GET_NOTIFICATION_RECIPIENTS = '[SETTINGS] Get Notification Recipients',
    GET_NOTIFICATION_RECIPIENTS_MORE = '[SETTINGS] Get Notification Recipients More',
    GET_NOTIFICATION_RECIPIENTS_SUCCESS = '[SETTINGS] Get Notification Recipients Success',
    GET_NOTIFICATION_RECIPIENTS_ERROR = '[SETTINGS] Get Notification Recipients Error',
    UPDATE_NOTIFICATION_RECIPIENT = '[SETTINGS] Update Notification Recipient',
    UPDATE_NOTIFICATION_RECIPIENT_SUCCESS = '[SETTINGS] Update Notification Recipient Success',
    UPDATE_NOTIFICATION_RECIPIENT_ERROR = '[SETTINGS] Update Notification Recipient Error',
  }

  export const getMailSubscription = createAction(Type.GET_MAIL_SUBSCRIPTION);

  export const getMailSubscriptionError = createAction(Type.GET_MAIL_SUBSCRIPTION_ERROR);

  export const getMailSubscriptionSuccess = createAction(
    Type.GET_MAIL_SUBSCRIPTION_SUCCESS,
    props<{
      notifications: boolean;
      email: string;
    }>()
  );

  export const setMailSubscription = createAction(
    Type.SET_MAIL_SUBSCRIPTION,
    props<{
      notifications: boolean;
    }>()
  );

  export const setMailSubscriptionSuccess = createAction(
    Type.SET_MAIL_SUBSCRIPTION_SUCCESS,
    props<{
      notifications: boolean;
    }>()
  );

  export const setMailSubscriptionError = createAction(Type.SET_MAIL_SUBSCRIPTION_ERROR);

  export const getCentralEmail = createAction(Type.GET_CENTRAL_EMAIL);
  export const getCentralEmailSuccess = createAction(
    Type.GET_CENTRAL_EMAIL_SUCCESS,
    props<{
      data: CentralEmailResponse;
    }>()
  );
  export const getCentralEmailError = createAction(
    Type.GET_CENTRAL_EMAIL_ERROR,
    props<{
      error: any;
    }>()
  );

  export const getCentralEmailNoEmailFound = createAction(Type.GET_CENTRAL_EMAIL_NO_EMAIL_FOUND);

  export const setCentralEmail = createAction(
    Type.SET_CENTRAL_EMAIL,
    props<{
      email: string;
    }>()
  );
  export const setCentralEmailSuccess = createAction(
    Type.SET_CENTRAL_EMAIL_SUCCESS,
    props<{
      data: CentralEmailResponse;
    }>()
  );
  export const setCentralEmailError = createAction(
    Type.SET_CENTRAL_EMAIL_ERROR,
    props<{
      error: any;
    }>()
  );

  export const updateCentralEmail = createAction(
    Type.UPDATE_CENTRAL_EMAIL,
    props<{
      email: string;
    }>()
  );
  export const updateCentralEmailSuccess = createAction(
    Type.UPDATE_CENTRAL_EMAIL_SUCCESS,
    props<{
      data: CentralEmailResponse;
    }>()
  );
  export const updateCentralEmailError = createAction(
    Type.UPDATE_CENTRAL_EMAIL_ERROR,
    props<{
      error: any;
    }>()
  );

  export const deleteCentralEmail = createAction(Type.DELETE_CENTRAL_EMAIL);
  export const deleteCentralEmailSuccess = createAction(Type.DELETE_CENTRAL_EMAIL_SUCCESS);
  export const deleteCentralEmailError = createAction(
    Type.DELETE_CENTRAL_EMAIL_ERROR,
    props<{
      error: any;
    }>()
  );

  export const getNotificationRecipients = createAction(Type.GET_NOTIFICATION_RECIPIENTS);
  export const getNotificationRecipientsMore = createAction(
    Type.GET_NOTIFICATION_RECIPIENTS_MORE,
    props<{
      data: NotificationRecipient[];
      cursor: string;
    }>()
  );
  export const getNotificationRecipientsSuccess = createAction(
    Type.GET_NOTIFICATION_RECIPIENTS_SUCCESS,
    props<{
      data: NotificationRecipient[];
    }>()
  );
  export const getNotificationRecipientsError = createAction(
    Type.GET_NOTIFICATION_RECIPIENTS_ERROR,
    props<{
      error: any;
    }>()
  );
  export const updateNotificationRecipient = createAction(
    Type.UPDATE_NOTIFICATION_RECIPIENT,
    props<{
      isActive: boolean;
      recipient: NotificationRecipient;
    }>()
  );
  export const updateNotificationRecipientSuccess = createAction(
    Type.UPDATE_NOTIFICATION_RECIPIENT_SUCCESS
  );
  export const updateNotificationRecipientError = createAction(
    Type.UPDATE_NOTIFICATION_RECIPIENT_ERROR,
    props<{
      recipientToRevert: NotificationRecipient;
      isActiveValue: boolean;
      error: any;
    }>()
  );
}
